import { render } from "./linkup.vue?vue&type=template&id=39269663"
import script from "./linkup.vue?vue&type=script&lang=js"
export * from "./linkup.vue?vue&type=script&lang=js"

import "./linkup.vue?vue&type=style&index=0&id=39269663&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__